import React from 'react'
import { StyledSwitch } from './Switch.styles'

export const Switch = ({
  id,
  checked,
  onChange,
  onMouseDown,
}: {
  id: string
  checked: boolean
  onChange: React.ChangeEventHandler<HTMLInputElement>
  onMouseDown?: React.MouseEventHandler<HTMLInputElement>
}): JSX.Element => {
  return (
    <StyledSwitch
      id={id}
      checked={checked}
      onChange={onChange}
      onMouseDown={onMouseDown}
    />
  )
}
